import mapFunction from './mapResources';

export default mapFunction('work_performance', {
    isFetching: false,
    items: [] 
});